module.exports = __webpack_public_path__ + "static/media/mirrorCorrect.16a5b69a.png";